const cneVotingUrl = 'https://lugarvotacion.cne.gob.ec/'

export function CneVotingLookup() {
  return (
    <section className="cne-voting-lookup" aria-labelledby="cne-voting-title">
      <h2 id="cne-voting-title">Consulta tu lugar de votación</h2>
      <iframe
        src={cneVotingUrl}
        title="Consulta oficial de lugar de votación del Consejo Nacional Electoral"
        className="cne-voting-lookup__frame"
        loading="lazy"
        referrerPolicy="strict-origin-when-cross-origin"
      />
      <p>
        Si la consulta no carga, <a href={cneVotingUrl} target="_blank" rel="noopener noreferrer">ábrela en el sitio del CNE</a>.
      </p>
    </section>
  )
}
